module.exports = __webpack_public_path__ + "src/img/verify-success-result-logo.907d236e.svg";